import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router'
import { analytics } from '../index'
import { useAuthStore } from '@/features/auth/store'

export function usePageTracking(): void {
  const location = useLocation()
  const initialized = useRef(false)
  const user = useAuthStore(state => state.user)

  // Analytics 초기화
  useEffect(() => {
    if (!initialized.current) {
      analytics.init()
      initialized.current = true
    }
  }, [])

  // User ID 설정 (로그인/로그아웃 시)
  useEffect(() => {
    if (initialized.current) {
      analytics.setUserId(user?.id || null)
    }
  }, [user?.id])

  // 페이지 변경 추적
  useEffect(() => {
    if (initialized.current) {
      const fullPath = location.pathname + location.search
      analytics.trackPageView(fullPath)
    }
  }, [location])
}
